import { PRODUCT_BRAND, PRODUCTS } from '@/config/products';

/** Product suite label used in document titles. */
export const COTASKR_SUITE_LABEL = 'Plan · Code · Ship · Lenc';

export function buildPageTitle(page: string): string {
  return `${page} · ${PRODUCT_BRAND}`;
}

export function buildSiteTitle(): string {
  return `${PRODUCT_BRAND} — ${COTASKR_SUITE_LABEL}`;
}

/** Plain-language summary of what each product does — used in meta tags. */
export const PRODUCT_OFFERINGS_SUMMARY = PRODUCTS.map(
  (p) => `${p.shortName}: ${p.description.toLowerCase()}`,
).join(' ');

export const DEFAULT_SITE_DESCRIPTION =
  'CoTaskr is an AI delivery suite for modern teams. Plan — project delivery, follow-ups, and time. Code — engineering workspace and repos. Ship — releases and deployments. Lenc — monitoring and alerts. One login, four products.';

export type RouteMeta = {
  title: string;
  description?: string;
};

/** Longest-prefix match for nested routes (e.g. /board/:id → /board). */
export function resolveRouteMeta(pathname: string, table: Record<string, RouteMeta>): RouteMeta {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (table[normalized]) return table[normalized];

  const segments = normalized.split('/').filter(Boolean);
  while (segments.length > 0) {
    const candidate = `/${segments.join('/')}`;
    if (table[candidate]) return table[candidate];
    segments.pop();
  }

  return table['/'] ?? { title: 'Workspace', description: DEFAULT_SITE_DESCRIPTION };
}

export function applyDocumentMeta(meta: RouteMeta): void {
  const title = buildPageTitle(meta.title);
  const description = meta.description ?? DEFAULT_SITE_DESCRIPTION;

  document.title = title;

  const descTag = document.querySelector('meta[name="description"]');
  if (descTag) descTag.setAttribute('content', description);

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute('content', title);

  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', description);

  const twTitle = document.querySelector('meta[name="twitter:title"]');
  if (twTitle) twTitle.setAttribute('content', title);

  const twDesc = document.querySelector('meta[name="twitter:description"]');
  if (twDesc) twDesc.setAttribute('content', description);
}
